import React from "react";

export default (metric, value, subHeader, buyBox=false) => {
  // This function is used by both LiteLineChart and LiteMetricTable
  // subHeader is only used by LiteMetricTable
  const monetaryMetrics0Precision = ["spend", "revenue", "customer_acquisition_cost"]
  const monetaryMetrics2Precision = ["roas", "cpa", "mer", "aov"]
  const standardMetrics2Precision = ["frequency"]
  const percentageMetrics2Precision = ["conversion_rate", "open_rate", "ctr", "bounce_rate", "open_rate"]
  const percentageMetrics0Precision = ["stacked"]
  const percentageSubHeaders = ["Y/Y", "YoY", "MoM", "Growth Rate"]
  // All other metrics are standard metrics with 0 precision

  if (buyBox == true) {
    let temp_metric = subHeader
    let temp_subHeader = metric
    metric = temp_metric
    subHeader = temp_subHeader
  }

  if (value === undefined || value === null) {
    return "";
  }
  let prefix = "";
  let suffix = "";
  let precision = 0;
  let multiplier = 1;
  if (percentageSubHeaders.includes(subHeader)) {
    suffix = "%";
  } else {
    if (standardMetrics2Precision.includes(metric)) {
      precision = 2;
    }
    if (percentageMetrics2Precision.includes(metric)) {
      precision = 2;
      suffix = "%";
      multiplier = 100;
    }
    if (percentageMetrics0Precision.includes(metric)) {
      suffix = "%";
    }
    if (monetaryMetrics0Precision.includes(metric)) {
      prefix = "$";
    }
    if (monetaryMetrics2Precision.includes(metric)) {
      precision = 2;
      prefix = "$";
    }
    if (metric == "buy_box_percentage") {
      suffix = "%";
    }
  }
  if (subHeader == "Diff") {
    if (value > 0) {
      prefix = "+" + prefix;
    }
  }

  value = parseFloat(value) * multiplier;

  // Conditional formatting for large numbers on ticks
  if (subHeader === "tick") {
    const absValue = Math.abs(value);
    if (absValue >= 1e9) {
      value = (value / 1e9).toFixed(absValue % 1e9 < 1e8 ? 0 : 1).replace(/\.0+$/, '') + 'b';
    } else if (absValue >= 1e6) {
      value = (value / 1e6).toFixed(absValue % 1e6 < 1e5 ? 0 : 1).replace(/\.0+$/, '') + 'm';
    } else if (absValue >= 1e3) {
      value = (value / 1e3).toFixed(absValue % 1e3 < 100 ? 0 : 1).replace(/\.0+$/, '') + 'k';
    } else {
      // For values < 1000, round to variable precision and remove trailing zeros
      value = value.toFixed(precision).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
    }
  } else {
    value = value.toFixed(precision);
    let valueParts = value.toString().split('.');
    value = valueParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (valueParts.length === 2 ? '.' + valueParts[1] : '');
  }

  let finalValue = `${prefix}${value}${suffix}`
  finalValue = finalValue.replace('$-', '-$')

  return finalValue
};
